<template>
  <div class="order-details-box" v-if="loading">

    <Sticky :offset-top="$fn.px2rem(88)" v-if="info.actStatus == 2">
      <div class="top-hint-box">
        <i>图标</i>
        <span>请在 <i>{{ getTime(info.expireTick - time) }}</i> 内完成支付，超时后订单自动关闭！</span>
      </div>
    </Sticky>

    <div class="status-box" v-else>
      <div class="sb-title">
        <template v-if="info.actStatus == 6">
          <img src="https://xhdata.wan4.com/wsw-h5-47.png">
          <span class="title-finish">交易完成</span>
        </template>
        <template v-else-if="info.actStatus == 7">
          <img src="https://xhdata.wan4.com/wsw-h5-44.png">
          <span style="color: #F53F3F;">交易关闭</span>
        </template>
        <template v-else-if="info.actStatus == 3">
          <img src="https://xhdata.wan4.com/wsw-h5-46.png">
          <span style="color: #FF6634;">待发货</span>
        </template>
        <template v-else-if="info.actStatus == 4">
          <img src="https://xhdata.wan4.com/wsw-h5-45.png">
          <span style="color: #FF6634;">待收货</span>
        </template>
      </div>
      <!-- 物流信息 -->
      <div class="wl-no" v-if="info.wlJson && info.wlJson.nu != '' && info.wlJson.data && info.wlJson.data.length > 0">
        <span style="color: #999;">物流单号：</span>
        <span style="color: #666;opacity: 0.9;">{{ info.comName }} </span>
        <span style="color: #333;opacity: 0.9;font-weight: bold;">{{ info.logiNo }}</span>
        <span class="copy" @click="copyText(info.logiNo)">复制</span>
      </div>
      <!-- 待收货状态，没有物流信息展示 -->
      <div class="wl-no" v-else-if="info.actStatus == 4">
        <span style="color: #666;">仓库处理中</span>
      </div>
      <!-- 物流详情 -->
      <div class="wl-info"
        v-if="info.wlJson && info.wlJson.nu != '' && info.wlJson.data && info.wlJson.data.length > 0">

        <div class="wl-item" v-if="!info.wlJson.show">
          <span class="wi-title">{{ info.wlJson.data[0].status }}<i>{{ info.wlJson.data[0].time.slice(5, 16)
              }}</i></span>
          <span class="wi-txt" style="margin-bottom: 0;">{{
            info.wlJson.data[0].context
            }}</span>

          <img src="https://xhdata.wan4.com/wsw-h5-48.png">
        </div>
        <template v-else>
          <div class="wl-item" v-for="item, index in info.wlJson.data" :key="index">
            <span class="wi-title">{{ item.status }}<i>{{ item.time.slice(5, 16) }}</i></span>
            <span class="wi-txt" :style="index + 1 == info.wlJson.data.length ? 'margin-bottom: 0;' : ''">{{
              item.context
              }}</span>

            <img src="https://xhdata.wan4.com/wsw-h5-48.png" v-if="index == 0">
            <i class="wl-icon1" v-else :class="{ 'wl-icon2': index + 1 == info.wlJson.data.length }"></i>
            <i class="wi-line" :class="{ 'wl-line1': index == 0 }" v-if="index + 1 < info.wlJson.data.length"></i>
          </div>
        </template>


        <span class="wl-details" :class="{ 'wl-details-on': info.wlJson.show }"
          @click="$set(info.wlJson, 'show', !info.wlJson.show)">物流详情</span>
      </div>
    </div>
    <input id="input" style="height: 0;border: 0;max-height: 0;padding: 0;" />
    <div class="addr-box" v-if="info.addr && info.addr.cmobile">
      <i class="icon-addr"></i>
      <span>{{ info.addr.cname }}/{{ info.addr.cmobile }}</span>
      <span>{{ info.addr.daddr }}{{ info.addr.daddr2 }}</span>
    </div>

    <!-- 付款方式 -->
    <template v-if="info.actStatus == 2">

      <span class="sub-title">付款方式</span>
      <div class="pay-type-box">
        <div @click="payMode = 0"><img src="https://xhdata.wan4.com/wsw-h5-wx-pay.png" /> <i
            :class="{ on: payMode == 0 }"></i></div>
        <div @click="payMode = 1"><img src="https://xhdata.wan4.com/wsw-h5-pay-ali.png" /> <i
            :class="{ on: payMode == 1 }"></i></div>
      </div>
    </template>
    <div class="list-box">
      <div class="item-box" v-for="item, index in info.orderList" :key="index">
        <div class="company-title-box">
          <span @click="$router.push('/goods/shop?type=3&memCode=' + item.memCode)">工厂{{ item.memCode }}</span>
        </div>
        <div class="goods-item" v-for="goods, gIndex in item.goodsList" :key="gIndex">
          <div class="sku-item" :class="{
            'sku-item-active': sku.opt,
            'sku-item-no-buttom-line': sku.opt && skuIndex < (goods.skuList.length - 1) && goods.skuList[skuIndex + 1].opt,
            'sku-item-no-top-line': sku.opt && skuIndex > 0 && goods.skuList[skuIndex - 1].opt
          }" v-for="sku, skuIndex in goods.skuList" :key="skuIndex">
            <i class="select sku-select" :class="{ 'select-on': sku.opt }" @click="optSku(sku)"></i>
            <div class="pic">
              <img v-lazy="sku.skuImgUrl + '?imageView2/1/w/120/h/120'" :key="sku.skuImgUrl"
                @click='showImagePreview([sku.skuImgUrl], 0)' />
            </div>
            <span class="title overflow">{{ goods.goodsName }}</span>
            <span class="goods-code">【商品编号：{{ goods.goodsCode }}】</span>
            <span class="sku-info">{{ getSkuStr(sku) }}</span>
            <div class="price-box"><span class="price">{{ $fn.initPrice(sku.price, 0) }}<i>{{ $fn.initPrice(sku.price,
              1)
                  }}</i><i>元/个</i></span><span>x{{ Number(sku.buyQty ||
                    0).toLocaleString() }}</span>
            </div>
          </div>
        </div>
        <div class="count-box">
          <span class="count-ttl">数量合计：<i>{{ Number(item.ttlQty || 0).toLocaleString() }}</i></span>
          <span class="count-ttl">规格合计：<i>{{ Number(item.ttlSku || 0).toLocaleString() }}</i></span>

          <span class="price-box"
            :data-car-fee="`运费: ${$fn.initPrice(item.carFee, 0)}${$fn.initPrice(item.carFee, 1)}元`">商品金额合计：<i>{{
              $fn.initPrice(item.ttlAmt, 0) }}</i><i>{{ $fn.initPrice(item.ttlAmt, 1)
              }}元</i></span>

          <i class="line"></i>

          <span class="price-ttl">
            金额合计(含运费)：<i>{{ $fn.initPrice(item.subTtl, 0) }}</i><i>{{ $fn.initPrice(item.subTtl, 1) }}元</i>
          </span>

        </div>

      </div>
    </div>
    <div class="pay-grand-box" v-if="info.actStatus != 2">
      <span>{{ info.actStatus == 7 ? '应付金额(含运费)：' : '实付金额：' }}</span>
      <span>{{ $fn.initPrice(info.grandTtl, 0) }}<i>{{ $fn.initPrice(info.grandTtl, 1) }}元</i></span>
    </div>

    <div class="order-info">
      <span>下单时间：<i>{{ info.doDate }}</i></span>
      <span>订单号：<i>{{ info.orderNo }}</i><i @click="showTimeListPopup = true">详情</i></span>
    </div>

    <div class="kf-box">
      <a @click="onKefuClick">
        <img src="https://xhdata.wan4.com/wsw-h5-50.png">
        <span>在线客服</span>
        <i>物流/售后咨询</i>
      </a>
      <a href="tel:18903033484">
        <img src="https://xhdata.wan4.com/wsw-h5-51.png">
        <span>客服电话</span>
        <i>18903033484</i>
      </a>
    </div>

    <div class="bottom-box" v-if="info.actStatus == 2">
      <span>应付金额：<i>{{ $fn.initPrice(info.grandTtl, 0) }}</i><i>{{ $fn.initPrice(info.grandTtl, 1) }}元</i></span>

      <van-button type="primary" @click="pay">立即支付</van-button>
    </div>

    <orderTimeListPopup v-model="showTimeListPopup" :orderNo="info.orderNo" :logList="info.logInfo">
    </orderTimeListPopup>


    <div class="top-right-box">
      <!-- 取消订单 -->
      <span v-if="info.actStatus == 2" @click="onCanceOrder">取消订单</span>
      <!-- 退款 -->
      <span v-if="info.actStatus == 3" @click="onRefund">退款</span>
    </div>
  </div>
  <!-- 空页面加载 -->
  <van-loading v-else type="spinner" color="#111111" />
</template>

<script>
import orderTimeListPopup from '../../components/orderTimeListPopup.vue';
import { Sticky, Toast, ImagePreview } from 'vant';
export default {
  name: 'OrderDetails',
  data() {
    return {
      loading: false,
      info: {},
      time: 0,
      payMode: 0,
      showTimeListPopup: false,
    }
  },
  created() {
    this.getData();
  },
  components: {
    Sticky, orderTimeListPopup
  },
  methods: {
    //查看大图
    showImagePreview(imgs, index) {
      ImagePreview({
        images: imgs,
        startPosition: index
      })
    },
    getData() {
      // /iap-api/wan4/order/orderDetailByPaymentSn.do
      let url = '/iap-api/wan4/order/buyerOrderDetail.do'
      if (this.$route.query.paymentSn) {
        url = '/iap-api/wan4/order/orderDetailByPaymentSn.do'
      }
      this.$ajax(url, { orderId: this.$route.query.orderId || '', paymentSn: this.$route.query.paymentSn || '' }).then(res => {
        this.loading = true;
        if (!this.$route.query.paymentSn) {
          res.data.orderList = [
            {
              goodsList: res.data.goodsList,
              memCode: res.data.memCode,
              carFee: res.data.carFee,
              ttlAmt: res.data.ttlAmt,
              ttlQty: res.data.ttlQty,
              ttlSku: res.data.ttlSku,
              subTtl: res.data.subTtl,
            }
          ]
        }
        this.info = res.data;

        this.time = new Date().getTime();
        if (this.setInterval) {
          clearInterval(this.setInterval)
        }
        if (res.data.actStatus == 2) {
          this.setInterval = setInterval(() => {
            this.time = new Date().getTime();
          }, 1000);
        }


      })
    },
    copyText(text) {
      var input = document.getElementById("input");
      input.value = text;
      input.select();
      document.execCommand("copy");
      this.$toastUtil.show('复制成功')
    },
    //倒计时
    getTime: function (time) {
      if (time < 0) {
        this.getData();
        return
      }
      let ts = time / 1000
      let f = parseInt(ts / 60)
      f < 0 ? f = 0 : ''
      let s = parseInt(ts % 60)
      s < 10 ? s = '0' + s : ''
      return f + ':' + s
    },
    getSkuStr(sku) {
      let arr = [];
      if (sku.colorText) {
        arr.push(sku.colorText)
      }
      if (sku.czText) {
        arr.push(sku.czText)
      }
      if (sku.sizeText) {
        if (sku.sizeText.indexOf("-∅") >= 0) {
          arr.push(sku.sizeText.slice(0, sku.sizeText.indexOf("-∅")))
        } else {
          arr.push(sku.sizeText)
        }
      }
      if (arr.length > 0) {
        return this.$fn.sliceJz(arr.join('；'))
      }
      return '-';
    },
    onKefuClick() {
      window.location.href = 'https://300094.sh.absoloop.com/webim/im.html?configId=bda4de80-6e5c-11ef-b8aa-53197c42598f&language=zh-CN'
    },
    pay() {
      this.$router.push(`/order/pay?paymentSn=${this.$route.query.paymentSn}&payMode=${this.payMode}`)
    },
    //取消订单
    onCanceOrder() {
      this.$dialog.confirm({
        message: `取消后，商品可能会被他人买走<br>确定 <span style='font-weight: bold;'>取消</span> 吗?`
      }).then(() => {
        this.$ajax('/iap-api/wan4/order/buyerCancelOrder.do', { paymentSn: this.info.paymentSn }).then(() => {
          this.getData()
        })
      }).catch(() => {
      });
    },
    //退款
    onRefund() {
      this.$dialog.confirm({
        message: `操作后，实付金额会原路退回支付的银行卡内！<br>确定 <span style='font-weight: bold;'>退款</span> 吗?`
      }).then(() => {
        const toast = Toast.loading({
          message: '退款中...',
          forbidClick: true,
          duration: 0,
          loadingType: 'spinner',
        });
        this.$ajax('/iap-api/wan4/order/buyerCancelPaidOrder.do', { orderId: this.info.orderId }).then(() => {
          this.getData()
          toast.clear();
        }, () => {
          toast.clear();
        })
      }).catch(() => {
      });
    }
  }
}
</script>

<style scoped lang="less">
.order-details-box {
  display: flex;
  flex-direction: column;
  padding-bottom: 120px;

  >* {
    flex-shrink: 0;
  }

  .top-hint-box {
    height: 80px;
    background: #fff7e8;
    align-items: center;
    display: flex;
    padding-left: 32px;

    >i {
      width: 40px;
      height: 40px;
      background: url('https://xhdata.wan4.com/wsw-h5-52.png') no-repeat center;
      background-size: 100% 100%;
      font-size: 0;

    }

    >span {
      color: #333;
      font-size: 24px;
      font-style: normal;
      font-weight: bold;
      line-height: 36px;
      margin-left: 9px;

      >i {
        font-size: 28px;
        color: #F53F3F;
      }
    }
  }

  .status-box {
    display: flex;
    flex-direction: column;
    padding: 32px 34px 32px 42px;
    border-radius: 8px;
    background: #FFF;
    margin: 20px 18px 0;

    .sb-title {
      display: flex;
      align-items: center;

      >img {
        width: 68px;
        height: 68px;
      }

      >span {
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        line-height: 68px;
        margin-left: 12px;
      }

      .title-finish {
        color: #47C56A;
      }
    }

    .wl-no {
      margin-top: 12px;

      >span {
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 34px;
      }

      .copy {
        color: #FF6634;
        text-decoration-line: underline;
        margin-left: 8px;
      }
    }

    .wl-info {
      border-radius: 8px;
      border: 2px dashed #DCDCDC;
      background: #F8F8F8;
      margin-top: 24px;
      padding: 28px 24px 24px 78px;
      position: relative;

      .wl-item {
        display: flex;
        flex-direction: column;
        position: relative;

        .wi-title {
          color: #333;
          font-size: 28px;
          font-style: normal;
          font-weight: 600;
          line-height: 34px;

          >i {
            color: #999;
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: 34px;
            margin-left: 18px;
          }
        }

        .wi-txt {
          margin-top: 8px;
          margin-bottom: 34px;
          color: #666;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 34px;
        }


        .wi-line {
          position: absolute;
          left: -34px;
          width: 2px;
          height: calc(100% - 17px);
          background: #D9D9D9;
          top: 25px;
        }

        .wl-line1 {
          top: 33px;
          height: calc(100% - 25px);
        }

        .wl-icon1 {
          position: absolute;
          width: 2px;
          left: -34px;
          z-index: 1;

          &::after {
            content: '';
            position: absolute;
            width: 17px;
            height: 17px;
            border: 3px solid #D9D9D9;
            background: #F8F8F8;
            border-radius: 20px;
            left: -10px;
            top: 7px;
          }
        }

        .wl-icon2 {

          &::after {
            background: #DCDCDC;
          }
        }

        >img {
          width: 42px;
          height: 42px;
          position: absolute;
          left: -54px;
          top: -4px;
          z-index: 1;
        }
      }

      .wl-details {
        position: absolute;
        top: 28px;
        right: 24px;
        color: #FF6634;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 34px;
        display: flex;
        align-items: center;

        &::after {
          content: '';
          width: 28px;
          height: 28px;
          background: url('https://xhdata.wan4.com/wsw-h5-49.png') no-repeat center;
          background-size: 28px 28px;
          margin-left: 6px;
          transition: 0.3s;
        }

        &-on {

          &::after {
            transform: rotate(180deg);
          }
        }
      }
    }

  }

  .addr-box {
    margin: 18px 18px 0;
    display: flex;
    flex-direction: column;
    position: relative;
    background: #fff;
    border-radius: 8px;
    min-height: 144px;
    padding: 32px 24px 32px 106px;

    .icon-addr {
      width: 58px;
      height: 58px;
      background: url('https://xhdata.wan4.com/wsw-h5-35.png') no-repeat center;
      background-size: 100%;
      position: absolute;
      left: 24px;
      top: 50%;
      transform: translateY(-50%);
    }

    >span {
      color: #333;
      font-size: 28px;
      font-style: normal;
      font-weight: bold;
      line-height: 34px;
    }

    >span+span {
      color: #333;
      font-size: 26px;
      font-style: normal;
      font-weight: 400;
      line-height: 34px;
      margin-top: 12px;
    }

  }

  .sub-title {
    color: #333;
    font-size: 32px;
    font-style: normal;
    font-weight: bold;
    line-height: 44px;
    margin: 20px 18px 0;
  }

  .pay-type-box {
    margin: 18px 18px 0;
    display: flex;

    >div {
      flex: 1;
      height: 100px;
      display: flex;
      background: #fff;
      padding: 0 24px;
      border-radius: 8px;
      align-items: center;

      &:first-child {
        margin-right: 14px;
      }

      >img {
        height: 36px;
      }

      >i {
        width: 32px;
        height: 32px;
        border: 2px solid #999;
        margin-left: auto;
        border-radius: 32px;
      }

      .on {
        width: 32px;
        height: 32px;
        border: 0px solid #999;
        margin-left: auto;
        background: url('https://xhdata.wan4.com/wsw-h5-21.png') no-repeat center;
        background-size: 32px;
        border-radius: 32px;
        border: 2px solid #ff6634;
        overflow: hidden;
      }
    }
  }



  .list-box {
    display: flex;
    flex-direction: column;

    .item-box {
      margin: 20px 18px 0;
      background: #fff;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      border-radius: 0px 0px 8px 8px;
      overflow: hidden;

      &:last-child {
        margin-bottom: 0;
      }

      .company-title-box {
        height: 76px;
        border-bottom: 1px solid #E5E5E5;
        display: flex;
        align-items: center;
        padding-left: 12px;

        >span {
          color: #333;
          font-size: 28px;
          font-style: normal;
          font-weight: 600;
          display: flex;
          align-items: center;

          &::after {
            content: '';
            width: 28px;
            height: 28px;
            margin-left: 2px;
            background: url('https://xhdata.wan4.com/wsw-h5-12.png') no-repeat center;
            background-size: 100%;
          }
        }
      }

      .count-box {
        display: flex;
        flex-direction: column;
        border-radius: 0px 0px 8px 8px;
        border-top: 1px solid #dcdcdc;
        background: linear-gradient(90deg, #FFFFFF80 68%, #FFD1C280 100%);
        padding: 18px 24px 0;
        position: relative;
        margin-top: 32px;

        .count-ttl {
          color: #999;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 34px;


          >i {
            color: #333;
            font-size: 24px;
            font-style: normal;
            font-weight: bold;
            line-height: 34px;
          }
        }

        .price-box {
          color: #999;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 34px;
          position: absolute;
          top: 18px;
          right: 24px;

          &::after {
            content: attr(data-car-fee);
            position: absolute;
            right: 0;
            top: 100%;
            color: #999;
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: 28px;
          }

          >i {
            color: #3F3F3F;
            font-size: 28px;
            font-style: normal;
            font-weight: bold;
            line-height: 44px;
          }

          >i+i {
            color: #3F3F3F;
            font-size: 24px;
            font-style: normal;
            font-weight: bold;
            line-height: 34px;
          }
        }

        .line {
          margin: 28px 0 0;
          height: 1px;
          background: #DCDCDC;
        }

        .price-ttl {
          height: 80px;
          margin-left: auto;
          color: #999;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 80px;
          align-items: center;

          >i {
            color: #F53F3F;
            font-size: 32px;
            font-weight: bold;
          }

          >i+i {
            font-size: 24px;
          }
        }
      }

      .goods-item {
        background: #F4F4F4;
        display: flex;
        flex-direction: column;
        margin: 24px 24px 0;
        border-radius: 4px;

        .sku-item {
          display: flex;
          flex-direction: column;
          border-radius: 4px;
          border: 1px solid #F4F4F4;
          padding: 32px 24px 32px 160px;
          position: relative;

          &-active {
            background: #FFF7E8;
            border: 1px solid #FF6634;
            z-index: 1;

            &::after {
              content: none !important;
            }
          }

          &-no-buttom-line {
            border-bottom: 1px solid #FFF7E8 !important;
            border-bottom-left-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
          }

          &-no-top-line {
            border-top: 1px solid #FFF7E8 !important;
            border-top-left-radius: 0 !important;
            border-top-right-radius: 0 !important;

            &::after {
              content: '' !important;
              background: #FF6634 !important;
            }
          }

          &::after {
            content: '';
            position: absolute;
            height: 1px;
            left: 24px;
            right: 24px;
            top: -3px;
            background: #DCDCDC;
          }

          &:first-child {
            padding-top: 24px;

            &::after {
              content: none;
            }
          }

          &-active {
            border: 1px solid #FF6634;
            background: #FFF7E8;
          }

          .sku-select {
            position: absolute;
            top: 65px;
            left: 12px;
          }

          .pic {
            position: absolute;
            border-radius: 4px;
            border: 2px solid #DCDCDC;
            width: 120px;
            height: 120px;
            top: 24px;
            left: 24px;
            overflow: hidden;

            >img {
              width: 100%;
              height: 100%;
            }

            >span {
              width: 100%;
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
              height: 38px;
              border-radius: 0px 0px 4px 4px;
              background: #00000099;
              color: #FFF;
              font-size: 24px;
              text-align: center;
              line-height: 38px;
            }
          }

          .title {
            color: #333;
            font-size: 24px;
            font-style: normal;
            font-weight: 600;
            line-height: 34px;
          }

          .goods-code {
            color: #666;
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: 34px;
            margin-top: 6px;
          }

          .sku-info {
            border-radius: 2px;
            background: #FFF;
            padding: 12px 18px;
            color: #333;
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: 34px;
            margin-top: 12px;
            word-break: break-all;
          }

          .price-box {
            display: flex;
            margin-top: 12px;

            .price {
              color: #F53F3F;
              font-family: Arial;
              font-size: 34px;
              font-style: normal;
              font-weight: 700;
              line-height: 34px;

              >i {
                color: #F53F3F;
                font-family: Arial;
                font-size: 24px;
                font-style: normal;
                font-weight: 700;
                line-height: 34px;
              }

              >i+i {
                color: #F53F3F;
                font-family: "PingFang SC";
                font-size: 24px;
                font-style: normal;
                font-weight: 600;
                line-height: 34px;
              }
            }

            >span+span {
              color: #333;
              font-family: Arial;
              font-size: 28px;
              font-style: normal;
              font-weight: 400;
              line-height: 34px;
              margin-left: auto;
            }
          }
        }

      }

    }
  }


  .pay-grand-box {
    border-radius: 8px;
    background: #FFF;
    height: 92px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    margin: 20px 18px 0;

    >span {
      color: #999;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 34px;
    }

    >span+span {
      color: #F53F3F;
      margin-left: auto;
      font-size: 32px;
      font-style: normal;
      font-weight: 600;
      line-height: 44px;

      >i {
        color: #F53F3F;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 34px;
      }

    }
  }

  .order-info {
    margin: 20px 18px 0;
    background: #fff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 6px 24px;
    min-height: 134px;
    >span {
      color: #999;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 34px;
      margin-top: 18px;
      display: flex;

      >i {
        color: #333;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 34px;
      }

      >i+i {
        color: #FF6634;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 34px;
        align-items: center;
        display: flex;
        margin-left: 12px;

        &::after {
          content: '';
          width: 28px;
          height: 28px;
          background: url('https://xhdata.wan4.com/wsw-h5-49.png') no-repeat center;
          background-size: 28px 28px;
          transform: rotate(-90deg);
        }
      }
    }
  }

  .kf-box {
    display: flex;
    margin: 20px 5px 32px;

    >a {
      margin: 0 13px;
      border-radius: 12px;
      border: 1px solid #DCDCDC;
      background: #FFF;
      height: 172px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 1;
      padding-left: 150px;
      position: relative;

      >span {
        color: #333;
        font-size: 30px;
        font-style: normal;
        font-weight: 600;
        line-height: 34px;
      }

      >i {
        color: #666;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 34px;
        margin-top: 8px;
      }

      >img {
        width: 88px;
        height: 88px;
        position: absolute;
        left: 38px;
      }
    }
  }

  .bottom-box {
    position: fixed;
    height: 120px;
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 1px solid #DCDCDC;
    background: #FFF;
    display: flex;
    padding: 0 24px;
    z-index: 99;

    >span {
      color: #999;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 34px;
      margin-top: 22px;
      position: relative;
      margin: 22px 0 auto;

      &::after {
        position: absolute;
        content: '(含运费)';
        top: 100%;
        left: 0;
        color: #999;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 34px;
      }

      >i {
        color: #F53F3F;
        font-size: 32px;
        font-style: normal;
        font-weight: bold;
        line-height: 44px;
      }

      >i+i {
        color: #F53F3F;
        font-size: 24px;
        font-style: normal;
        font-weight: bold;
        line-height: 34px;
      }
    }

    .van-button {
      width: 220px;
      height: 86px;
      border-radius: 8px;
      margin-top: 18px;
      margin-left: auto;
    }
  }


  .top-right-box {
    top: 0;
    height: 88px;
    right: 0;
    position: fixed;
    padding: 0 24px;
    color: #999;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 88px;
    text-decoration-line: underline;
    z-index: 1000;
  }

}
</style>
